import { render, staticRenderFns } from "./sub-icon-primary.vue?vue&type=template&id=6d4c295e&scoped=true&"
import script from "./sub-icon-primary.vue?vue&type=script&lang=js&"
export * from "./sub-icon-primary.vue?vue&type=script&lang=js&"
import style0 from "./sub-icon-primary.vue?vue&type=style&index=0&id=6d4c295e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c295e",
  null
  
)

export default component.exports